// ALT YÜKLENİCİ İŞ KALEMLERİ (sözleşme): yapacağı işler = POZLARIMIZ (ürün
// kartı, kod = poz no) + anlaşılan birim fiyat ve para birimi. Günlük raporda
// yapılan iş bu listeden seçilir; fiyat alt yükleniciye gösterilmez.
// Kurallar sunucuda: backend/routes/insaat.py — ALT YÜKLENİCİ İŞ KALEMLERİ.
import { useCallback, useEffect, useState } from 'react';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import ProductCombobox from '@/components/ProductCombobox';
import ImportDialog from '@/components/ImportDialog';
import { Plus, FileSpreadsheet, Check } from 'lucide-react';
import { toast } from 'sonner';

const PARA_BIRIMLERI = ['TRY', 'GBP', 'EUR', 'USD'];
const fiyatYaz = (v) => Number(v || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 });
const secim = 'h-9 rounded-md border border-[#d0c4b0] bg-white px-2 text-sm';

const IMPORT_SUTUNLARI = [
  { key: 'poz_no', label: 'Poz No' },
  { key: 'poz_adi', label: 'İş', render: (r) => r.poz_adi || '—' },
  { key: 'birim', label: 'Birim', render: (r) => r.birim || '—' },
  { key: 'birim_fiyat', label: 'Birim Fiyat', render: (r) => `${r.birim_fiyat ?? ''} ${r.para_birimi || ''}` },
  { key: 'durum', label: 'Durum', render: (r) => r.durum || '—' },
];

export default function IsKalemleriDialog({ sub, open, onOpenChange, onDegisti }) {
  const [kalemler, setKalemler] = useState([]);
  const [pozlar, setPozlar] = useState([]);
  const [yeni, setYeni] = useState({ product_card_id: '', birim_fiyat: '', para_birimi: 'TRY' });
  const [duzen, setDuzen] = useState({});          // kalem_id -> {birim_fiyat, para_birimi}
  const [pasifGoster, setPasifGoster] = useState(false);
  const [mesgul, setMesgul] = useState(false);
  const [excelAcik, setExcelAcik] = useState(false);

  const yukle = useCallback(async () => {
    if (!sub) return;
    try {
      const r = await api.get(`/insaat/subcontractors/${sub.id}/kalemler`);
      setKalemler(r.data);
      setDuzen({});
    } catch (e) { toast.error(e?.response?.data?.detail || 'İş kalemleri alınamadı'); }
  }, [sub]);

  useEffect(() => {
    if (!open) return;
    yukle();
    api.get('/products', { params: { per_page: 5000 } })
      .then(r => setPozlar((r.data.items || r.data).map(p => ({ id: p.id, name: p.name, code: p.code, unit: p.unit }))))
      .catch(() => {});
  }, [open, yukle]);

  const guncel = (liste) => { setKalemler(liste); setDuzen({}); onDegisti?.(); };

  const ekle = async () => {
    if (!yeni.product_card_id) { toast.error('Poz seçin'); return; }
    if (yeni.birim_fiyat === '') { toast.error('Birim fiyat girin'); return; }
    setMesgul(true);
    try {
      const r = await api.post(`/insaat/subcontractors/${sub.id}/kalemler`, yeni);
      guncel(r.data);
      setYeni(p => ({ ...p, product_card_id: '', birim_fiyat: '' }));
      toast.success('İş kalemi eklendi');
    } catch (e) { toast.error(e?.response?.data?.detail || 'Eklenemedi'); }
    setMesgul(false);
  };

  const kaydet = async (k, alanlar) => {
    setMesgul(true);
    try {
      const r = await api.patch(`/insaat/kalemler/${k.id}`, alanlar);
      guncel(r.data);
      toast.success('Kaydedildi');
    } catch (e) { toast.error(e?.response?.data?.detail || 'Kaydedilemedi'); }
    setMesgul(false);
  };

  if (!sub) return null;
  const tanimli = new Set(kalemler.filter(k => k.aktif).map(k => k.product_card_id));
  const secilebilir = pozlar.filter(p => !tanimli.has(p.id));
  const gorunen = kalemler.filter(k => pasifGoster || k.aktif);
  const pasifSayisi = kalemler.filter(k => !k.aktif).length;

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-4xl max-h-[92vh] overflow-y-auto bg-[#faf7f2]" data-testid="is-kalemleri-pencere">
          <DialogHeader>
            <DialogTitle>{sub.name} — İş Kalemleri</DialogTitle>
            <DialogDescription>
              Alt yüklenicinin yapacağı işler (pozlar) ve anlaşılan birim fiyatlar. Günlük raporda yapılan iş bu
              listeden seçilir; fiyat alt yükleniciye gösterilmez. Fiyat değişikliği eski raporları etkilemez.
            </DialogDescription>
          </DialogHeader>

          {/* Yeni kalem */}
          <div className="rounded-lg border border-[#d0c4b0] bg-white p-3 space-y-2">
            <p className="text-xs font-semibold text-[#3F3E39]">Kalem ekle</p>
            {pozlar.length === 0 && (
              <p className="text-xs text-[#9b3b2f]">
                Bu şirkette henüz poz (ürün kartı) yok. Önce Stok Yönetimi → Ürün Kartları'ndan poz listesini
                yükleyin (kod = poz no).
              </p>
            )}
            <div className="grid gap-2 md:grid-cols-[1fr_9rem_6rem_auto] items-center">
              <ProductCombobox value={yeni.product_card_id} products={secilebilir}
                onChange={(v) => setYeni(p => ({ ...p, product_card_id: v }))}
                placeholder="Poz seçin (no ya da ad ile ara)" emptyText="Poz bulunamadı" testId="kalem-poz" />
              <Input type="number" step="any" min="0" value={yeni.birim_fiyat} placeholder="Birim fiyat"
                onChange={(e) => setYeni(p => ({ ...p, birim_fiyat: e.target.value }))}
                className="bg-white border-[#d0c4b0] text-right" data-testid="kalem-fiyat" />
              <select value={yeni.para_birimi} onChange={(e) => setYeni(p => ({ ...p, para_birimi: e.target.value }))}
                className={secim} data-testid="kalem-pb">
                {PARA_BIRIMLERI.map(pb => <option key={pb}>{pb}</option>)}
              </select>
              <Button onClick={ekle} disabled={mesgul} data-testid="kalem-ekle"
                className="bg-[#2e2d29] text-[#f5f0e8] hover:bg-[#1a1916]"><Plus size={14} className="mr-1" />Ekle</Button>
            </div>
          </div>

          <div className="flex items-center justify-between gap-2">
            <label className="text-xs text-[#8a7e70] flex items-center gap-1.5">
              {pasifSayisi > 0 && <>
                <input type="checkbox" checked={pasifGoster} onChange={(e) => setPasifGoster(e.target.checked)} />
                Pasif kalemleri göster ({pasifSayisi})
              </>}
            </label>
            <Button size="sm" variant="outline" onClick={() => setExcelAcik(true)} className="border-[#d0c4b0]"
              data-testid="kalem-excel"><FileSpreadsheet size={14} className="mr-1" />Excel'den yükle / güncelle</Button>
          </div>

          <div className="rounded-lg border border-[#d0c4b0] overflow-hidden bg-white">
            <Table>
              <TableHeader>
                <TableRow className="bg-[#e8dfd0] hover:bg-[#e8dfd0]">
                  <TableHead className="text-xs uppercase font-bold text-[#1a1916]">Poz No</TableHead>
                  <TableHead className="text-xs uppercase font-bold text-[#1a1916]">İş</TableHead>
                  <TableHead className="text-xs uppercase font-bold text-[#1a1916]">Birim</TableHead>
                  <TableHead className="text-xs uppercase font-bold text-[#1a1916] text-right">Birim Fiyat</TableHead>
                  <TableHead className="text-xs uppercase font-bold text-[#1a1916]">PB</TableHead>
                  <TableHead className="text-right"></TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {gorunen.length === 0 && (
                  <TableRow><TableCell colSpan={6} className="text-center text-sm text-[#8a7e70] py-6">
                    Henüz iş kalemi yok. Bu alt yüklenici günlük raporda yalnız "ilave iş" girebilir.
                  </TableCell></TableRow>
                )}
                {gorunen.map(k => {
                  const d = duzen[k.id];
                  const degisti = d && (Number(d.birim_fiyat) !== k.birim_fiyat || d.para_birimi !== k.para_birimi);
                  return (
                    <TableRow key={k.id} className={`border-[#d0c4b0] ${k.aktif ? '' : 'opacity-50'}`} data-testid={`kalem-${k.poz_no}`}>
                      <TableCell className="font-mono text-sm">{k.poz_no}</TableCell>
                      <TableCell className="text-sm">
                        {k.poz_adi}
                        {k.poz_aciklama && <span className="block text-[11px] text-[#8a7e70] line-clamp-1">{k.poz_aciklama}</span>}
                      </TableCell>
                      <TableCell className="text-sm text-[#5c554b]">{k.birim || '—'}</TableCell>
                      <TableCell className="text-right">
                        {k.aktif ? (
                          <Input type="number" step="any" min="0" value={d ? d.birim_fiyat : k.birim_fiyat}
                            onChange={(e) => setDuzen(p => ({ ...p, [k.id]: { birim_fiyat: e.target.value, para_birimi: (d || k).para_birimi } }))}
                            className="h-8 w-28 ml-auto bg-white border-[#d0c4b0] text-right font-mono" />
                        ) : <span className="font-mono text-sm">{fiyatYaz(k.birim_fiyat)}</span>}
                      </TableCell>
                      <TableCell>
                        {k.aktif ? (
                          <select value={(d || k).para_birimi} className={`${secim} h-8`}
                            onChange={(e) => setDuzen(p => ({ ...p, [k.id]: { birim_fiyat: (d || k).birim_fiyat, para_birimi: e.target.value } }))}>
                            {PARA_BIRIMLERI.map(pb => <option key={pb}>{pb}</option>)}
                          </select>
                        ) : <span className="text-sm">{k.para_birimi}</span>}
                      </TableCell>
                      <TableCell className="text-right whitespace-nowrap">
                        {degisti && (
                          <Button size="sm" disabled={mesgul} onClick={() => kaydet(k, d)}
                            className="h-8 bg-[#3d6e4e] text-white hover:bg-[#2d5a3c] mr-1"><Check size={13} /></Button>
                        )}
                        <Button size="sm" variant="ghost" disabled={mesgul} className="h-8 text-xs"
                          onClick={() => kaydet(k, { aktif: !k.aktif })}>
                          {k.aktif ? 'Pasife al' : 'Aktif et'}
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </DialogContent>
      </Dialog>
      <ImportDialog open={excelAcik} onOpenChange={setExcelAcik} config={{
        title: `${sub.name} — İş Kalemlerini Excel'den Yükle`,
        templateUrl: `/insaat/subcontractors/${sub.id}/kalemler/sablon`,
        previewUrl: `/insaat/subcontractors/${sub.id}/kalemler/onizle`,
        executeUrl: `/insaat/subcontractors/${sub.id}/kalemler/aktar`,
        columns: IMPORT_SUTUNLARI,
        onComplete: () => { yukle(); onDegisti?.(); },
      }} />
    </>
  );
}
